const configHttpInterceptors = $httpProvider => {
	$httpProvider.interceptors.push('InterceptorAuth');
	// $httpProvider.interceptors.push('InterceptorMock');
	$httpProvider.interceptors.push('InterceptorStatusCodes');
};
configHttpInterceptors.$inject = ['$httpProvider'];
export default configHttpInterceptors;
